const UNITS = [['day', 86400], ['hour', 3600], ['minute', 60]];

/** "just now", "1 minute ago", "5 hours ago", "2 days ago". */
const timeAgo = (isoString, now = Date.now()) => {
  const seconds = Math.max(0, Math.floor((now - Date.parse(isoString)) / 1000));
  const unit = UNITS.find(([, size]) => seconds >= size);
  if (!unit) return 'just now';
  const [name, size] = unit;
  const count = Math.floor(seconds / size);
  return `${count} ${name}${count === 1 ? '' : 's'} ago`;
};

export default timeAgo;
